module.exports = __webpack_public_path__ + "static/media/culture_hover.c0a34fa9.jpg";